(function () {
  const UPLOAD_PROP_KEYS = ['_Plik graficzny', '_Plik Graficzny', 'Plik graficzny', 'Plik Graficzny'];
  const TILT_THUMB_PROP_KEY = '_thumb_url';
  const CUSTOMILY_THUMB_PROP_KEY = '_customily-thumb';
  const PRIVATE_PROPERTY_LABELS = ['_design_id', '_thumb_url', '_customily-thumb'];
  const HIDE_PROPERTY_LABELS = ['wizualizacja rozgrywki', 'obszar spadu'];
  const CART_URL = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart.js';
  const FETCH_TTL_MS = 2000;
  const STATE = {
    lastFetchAt: 0,
    fetchPromise: null,
    scheduled: false
  };

  function getFilename(url) {
    if (typeof url !== 'string' || !url) return '';
    const clean = url.split('?')[0];
    const last = clean.split('/').pop() || '';
    try {
      return decodeURIComponent(last);
    } catch (e) {
      return last;
    }
  }

  function shouldFetch() {
    return !STATE.fetchPromise || (Date.now() - STATE.lastFetchAt) > FETCH_TTL_MS;
  }

  function fetchCart() {
    if (!shouldFetch()) return STATE.fetchPromise;
    STATE.fetchPromise = fetch(CART_URL, { credentials: 'same-origin' })
      .then(r => (r.ok ? r.json() : null))
      .catch(() => null)
      .finally(() => {
        STATE.lastFetchAt = Date.now();
      });
    return STATE.fetchPromise;
  }

  function clearNode(anchor) {
    if (!anchor) return;
    const node = anchor.querySelector('.upcart-customily-upload');
    if (node) node.remove();
  }

  function applyThumbToProductImage(itemEl, thumbUrl) {
    if (!itemEl) return;
    const img = itemEl.querySelector('.upcart-product-image-wrapper img, .styles_ProductRow__imageWrapper__ img');
    if (!img) return;

    if (thumbUrl) {
      if (!img.dataset.customilyOriginalSrc) {
        img.dataset.customilyOriginalSrc = img.currentSrc || img.src || '';
        img.dataset.customilyOriginalSrcset = img.getAttribute('srcset') || '';
        img.dataset.customilyOriginalSizes = img.getAttribute('sizes') || '';
      }
      if (img.src !== thumbUrl) {
        img.src = thumbUrl;
      }
      img.srcset = thumbUrl;
      img.setAttribute('data-customily-thumb', 'true');
    } else if (img.dataset.customilyOriginalSrc) {
      img.src = img.dataset.customilyOriginalSrc;
      if (img.dataset.customilyOriginalSrcset) {
        img.setAttribute('srcset', img.dataset.customilyOriginalSrcset);
      } else {
        img.removeAttribute('srcset');
      }
      if (img.dataset.customilyOriginalSizes) {
        img.setAttribute('sizes', img.dataset.customilyOriginalSizes);
      } else {
        img.removeAttribute('sizes');
      }
      img.removeAttribute('data-customily-thumb');
      delete img.dataset.customilyOriginalSrc;
      delete img.dataset.customilyOriginalSrcset;
      delete img.dataset.customilyOriginalSizes;
    }
  }

  function getUploadUrl(props) {
    if (!props || typeof props !== 'object') return '';

    for (const key of UPLOAD_PROP_KEYS) {
      const v = props[key];
      if (typeof v === 'string' && v) return v;
    }

    const matchKey = Object.keys(props).find(k => /_?plik graficzny/i.test(k));
    if (matchKey && typeof props[matchKey] === 'string') return props[matchKey];

    return '';
  }

  function getPreferredThumbUrl(props) {
    if (!props || typeof props !== 'object') return '';

    const tiltThumb = props[TILT_THUMB_PROP_KEY];
    if (typeof tiltThumb === 'string' && tiltThumb.trim()) return tiltThumb.trim();

    const customilyThumb = props[CUSTOMILY_THUMB_PROP_KEY];
    if (typeof customilyThumb === 'string' && customilyThumb.trim()) return customilyThumb.trim();

    return '';
  }

  function hideUnwantedProperties(itemEl) {
    const propsRoot = itemEl.querySelector('.upcart-item-properties');
    if (!propsRoot) return;
    propsRoot.querySelectorAll('.upcart-item-property').forEach(row => {
      const strong = row.querySelector('strong');
      if (!strong) return;
      const label = strong.textContent.replace(':', '').trim().toLowerCase();
      if (label.charAt(0) === '_' || PRIVATE_PROPERTY_LABELS.includes(label) || HIDE_PROPERTY_LABELS.includes(label)) {
        row.remove();
      }
    });
  }

  function applyToItem(itemEl, itemData) {
    const anchor = itemEl.querySelector('.upcart-item-properties-anchor-after');

    const props = itemData && itemData.properties;
    const fileUrl = getUploadUrl(props);
    const thumbUrl = getPreferredThumbUrl(props);
    if (!fileUrl && !thumbUrl) {
      clearNode(anchor);
      applyThumbToProductImage(itemEl, '');
      return;
    }

    hideUnwantedProperties(itemEl);

    clearNode(anchor);
    applyThumbToProductImage(itemEl, thumbUrl);
  }

  async function updateUpcart() {
    const cartRoot =
      document.getElementById('upCart') ||
      document.getElementById('CartPopup') ||
      document.querySelector('.upcart-cart');
    if (!cartRoot) return;

    const items = cartRoot.querySelectorAll('.upcart-product-item');
    if (!items.length) return;

    const cart = await fetchCart();
    if (!cart || !Array.isArray(cart.items)) return;

    const map = new Map(cart.items.map(item => [item.key, item]));
    items.forEach(el => applyToItem(el, map.get(el.id)));
  }

  function scheduleUpdate() {
    if (STATE.scheduled) return;
    STATE.scheduled = true;
    window.setTimeout(() => {
      STATE.scheduled = false;
      updateUpcart();
    }, 50);
  }

  function init() {
    if (!document.body) return;

    const observer = new MutationObserver(muts => {
      for (const m of muts) {
        if (m.type === 'childList') {
          if ([...m.addedNodes].some(n => n.nodeType === 1 && (n.id === 'upCart' || n.id === 'CartPopup' || n.classList?.contains('upcart-cart') || n.querySelector?.('#upCart, #CartPopup, .upcart-cart')))) {
            scheduleUpdate();
            continue;
          }
          if ([...m.addedNodes].some(n => n.nodeType === 1 && (n.classList?.contains('upcart-product-item') || n.querySelector?.('.upcart-product-item')))) {
            scheduleUpdate();
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    scheduleUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
